import { Col, Row, Typography } from "antd"
import { useTitle } from "hooks/useTitle"
import { ListingActionButtons } from "layoutsV2/pro/ProNewListingLayout/ListingActionButtons"
import useLoaderWatchers from "modules/loader-watchers/hooks/useLoaderWatchers"
import { serialize } from "object-to-formdata"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useParams, useSearchParams, useNavigate } from "react-router-dom"
import { modelSelector } from "store/selectors"
import { getGuideTrip, updateTrip } from "store/trips"
import { PreviewAbout } from "./PreviewAbout"
import { PreviewAddress } from "./PreviewAddress"
import { PreviewGuide } from "./PreviewGuide"
import { PreviewMediaListing } from "./PreviewMedia"
import { PreviewMeetingLocation } from "./PreviewMeetingLocation"
import ActionsPanel from "./ActionsPanel"
import { routes } from "router"
import styles from "./ExperiencesPreview.module.css"
import BookingDetailCard from "pagesV2/pro/Embedded/ExperienceBooking/BookingDetailCard"

const { Title } = Typography

export const ListingPreview = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  useLoaderWatchers({ watchers: ["trips.trip"] })

  const trip = useSelector(modelSelector("trip"))
  const params = useParams()
  const [searchParams] = useSearchParams();
  const routeType = searchParams.get("route");
  const isPreviewMode = searchParams.get("readOnlyPreview") === "true";
  useTitle(trip.title)

  useEffect(() => {
    const id = params.id
    const previewDetail = true
    window.scrollTo(0, 0)
    if (id) {
      dispatch(getGuideTrip(id, previewDetail))
    }
  }, [params.id])

  const { id, title } = trip

  const onFinish = (callback) => {
    const formData = serialize(
      {
        trip: {
          wizard_completed: true
        }
      },
      { allowEmptyArrays: true }
    )
    dispatch(updateTrip(id, formData)).then(callback)
  }

  const handleEdit = () => {
    if (routeType === "deactivated") {
      navigate(routes?.proEditExperienceDeactivateBackRoutePathDetails({ id: trip?.id }));
    } else if (routeType === "draft") {
      navigate(routes?.proEditExperienceDraftBackRoutePathDetails({ id: trip?.id }));
    } else if (routeType === "published") {
      navigate(routes?.proEditExperiencePublishBackRoutePathDetails({ id: trip?.id }));
    }
  }

  return (
    <>
      <div style={{ position: "relative", paddingRight: "100px" }}>
        <Title level={2} style={{ lineHeight: 1, marginBottom: 0 }}>
          {title}
        </Title>
      </div>
      <PreviewAddress trip={trip} t={t} />
      <PreviewMediaListing trip={trip} />
      <Row style={{ paddingBottom: 150 }}>
        <Col span={24} lg={24} xl={15} style={{ marginBottom: "20px" }}>
          <PreviewAbout trip={trip} t={t} />
          <PreviewMeetingLocation trip={trip} t={t} />
          <PreviewGuide trip={trip} t={t} />
        </Col>
        <Col span={24} lg={24} xl={9} className={styles.formCard}>
          {!isPreviewMode ? <BookingDetailCard bookNow={false} trip={trip} bookingButtonVisible={true} /> : <ActionsPanel trip={trip} onEdit={handleEdit} routeType={routeType} />}
        </Col>
      </Row>
      <ListingActionButtons onFinish={onFinish} isPreviewMode={isPreviewMode} />
    </>
  )
}